module.exports = __webpack_public_path__ + "img/bd.33b0d66b.svg";